// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../../mass-channel-customer-follow-up/state/report';
import actions from '../../actions-list';

const updateMassChannelCustomerFollowUpReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_MASS_CHANNEL_CUSTOMER_FOLLOW_UP_REPORT_SUCCESS]: updateMassChannelCustomerFollowUpReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: updateMassChannelCustomerFollowUpReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/mass-channel-customer-follow-up/reducers/report.js